import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles } from "../commonStyles.js";

export async function renderCarouselWidget(context, widget, parent, override = null) {

    const breakpoint = context.currentBreakpoint;
    const props = widget?.properties?.desktop;

    // Root carousel element
    const el = context.document.createElement("div");
    el.classList.add("widget", "carousel_widget");

    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...getCarouselStyles(widget)
    };

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    parent.appendChild(el);

    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return el;
    
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
    
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;
    
        const renderer = context.renderers[child.type];
        if (!renderer) continue;
    
        const childOverride = i === 0 ? null : true;
    
        await renderer(context, child, el, childOverride);
    }    

    return el;
}

function getCarouselStyles(widget) {
    const styles = {};

    const props = widget?.properties?.desktop;
    if (!props) return styles;

    const layout = props.layout;

    if ((!layout?.width || layout.width === "") && props.stretched === true) {
        styles.width = "100%";
    }

    return styles;
}